module.exports = __webpack_public_path__ + "static/images/challenge.275e0c221fe024895f04ce54c7bf7521.jpg";